import React from 'react';
import {Formik} from "formik";
import {FormikProps} from "formik/dist/types";
import {CompanyRuleDto} from "../../model/company/CompanyRuleDto";
import {companyAccountsStore} from "../../store/CompanyAccounts";
import {TxType} from "../../model/MatchedDocument";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import './RuleUpdateDialog.css'

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem,} from "@mui/material";
import TextFieldWithValidation from "../../components/input/TextFieldWithValidation";
import {observer} from "mobx-react";
import AccountCodeSelector from "../../components/selector/AccountCodeSelector";

interface IProps {
    show: boolean,
    initData: CompanyRuleDto,
    onSubmit: (updated: CompanyRuleDto, old: CompanyRuleDto) => void,
    onCancel: () => void
}

interface IState {
}

@observer
export default class RuleUpdateDialog extends React.Component<IProps, IState> {

    async componentDidMount() {
        await companyAccountsStore.refresh()
    }

    render() {
        const {show, initData} = this.props;
        return (
            <>
                <Dialog open={show} onClose={this.props.onCancel} aria-labelledby="form-dialog-title">
                    <Formik
                        initialValues={initData}
                        onSubmit={this.saveAndClose}
                        validate={this.validateModalDialogData}>
                        {(props: FormikProps<CompanyRuleDto>) => this.renderChangeRuleForm(props)}
                    </Formik>
                </Dialog>
            </>
        );
    }

    private renderChangeRuleForm(props: FormikProps<CompanyRuleDto>) {
        return <>
            <DialogTitle>Change rule</DialogTitle>
            <DialogContent id="update-rules-dialog">
                <TextFieldWithValidation
                    autoComplete="off"
                    name="descContains" label="Description"
                    placeholder="Description contains"
                    defaultValue={props.values.descContains}
                    fullWidth={true}
                    onChange={props.handleChange}
                    hasError={props.errors.descContains}
                    helperText="Will check if transaction description contains this text"
                    errorText="Please fill in at least description, creditor or debitor"
                />

                <TextFieldWithValidation
                    autoComplete="off"
                    name="debitorNameContains" label="Debitor"
                    placeholder="Debitor contains"
                    defaultValue={props.values.debitorNameContains}
                    fullWidth={true}
                    onChange={props.handleChange}
                    hasError={props.errors.debitorNameContains}
                    helperText="Will check if transaction debitor name contains this text"
                    errorText="Please fill in at least description, creditor or debitor"
                />

                <TextFieldWithValidation
                    autoComplete="off"
                    name="creditorNameContains" label="Creditor"
                    placeholder="Creditor contains"
                    defaultValue={props.values.creditorNameContains}
                    fullWidth={true}
                    onChange={props.handleChange}
                    hasError={props.errors.creditorNameContains}
                    helperText="Will check if transaction creditor name contains this text"
                    errorText="Please fill in at least description, creditor or debitor"
                />

                <TextFieldWithValidation
                    select={true}
                    name="txType"
                    label="TX Type"
                    placeholder="Transaction type"
                    defaultValue={props.values.txType}
                    fullWidth={true}
                    onChange={props.handleChange}
                    hasError={props.errors.txType}
                    errorText="Transaction type is mandatory"
                >
                    <MenuItem key="undefined" value={undefined}>Choose...</MenuItem>
                    <MenuItem key={TxType.DBIT} value={TxType.DBIT}>DBIT</MenuItem>
                    <MenuItem key={TxType.CRDT} value={TxType.CRDT}>CRDT</MenuItem>
                </TextFieldWithValidation>

                <AccountCodeSelector
                    label="Account code"
                    value={props.values.accCode}
                    hasError={props.errors.accCode}
                    placeholder="Account code"
                    errorText="Account code is mandatory"
                    onChanged={code => props.setFieldValue("accCode", code, true)}
                />
            </DialogContent>
            <DialogActions>
                <Button color="secondary" variant={"outlined"} onClick={this.props.onCancel}
                        startIcon={<CancelIcon/>}>Cancel</Button>
                <Button onClick={props.submitForm} variant={"outlined"} startIcon={<SaveAltIcon/>}
                        color="primary">Save</Button>
            </DialogActions>
        </>
    }

    private validateModalDialogData = (values: CompanyRuleDto) => {
        // @ts-ignore
        let errors: CompanyRuleDto = {};

        if (!values.descContains && !values.debitorNameContains && !values.creditorNameContains) {
            errors.descContains = 'invalid';
            errors.creditorNameContains = 'invalid';
            errors.debitorNameContains = 'invalid';
        }

        if (!values.txType) {
            // @ts-ignore
            errors.txType = 'invalid'
        }

        if (!values.accCode) {
            // @ts-ignore
            errors.accCode = 'invalid'
        }

        return errors;
    };

    private saveAndClose = async (changed: CompanyRuleDto) => {
        await this.props.onSubmit(changed, this.props.initData)
    }
}